import { NetworkError } from '@/utils/notification'

/**
 * @description
 *    Fetches the endpoint given as json and unpacks it
 * @param endpoint
 *    The endpoint needed to be fetched
 * @param acceptHtml
 *    Fetch from endpoint which returns html
 */
// eslint-disable-next-line func-names
export default async function (endpoint, acceptHtml = false) {
  try {
    const res = await fetch(endpoint, {
      headers: {
        Accept: 'application/json',
      },
    })
    return acceptHtml ? await res.text() : await res.json()
  } catch (e) {
    new NetworkError({ ex: e }).dispatch()
    return []
  }
}
